<template>
  <div>
    <search-form />

    <div v-if="draws">
      <div class="leaders__search-info">
        <span class="h5 mb-0">{{ selectBy === 'horse' ? draws[0].horse_name : draws[0].rider.name }}</span>
        <span>Total nominations: {{ draws.length }}</span>
        <span>Average score: {{ (draws.reduce((sum, draw) => sum + (+draw.round_score || 0), 0) / draws.length).toFixed(2) }}</span>
      </div>

      <div
        class="cut-table leaders__search-results table-hover table-striped"
      >
        <div class="cut-table__header">
          <div class="cut-table__row row m-0">
            <div class="cut-table__cell col-2 hidden-md"><strong>Event</strong></div>
            <div class="cut-table__cell col-9 display-md"><strong>Info</strong></div>
            <div class="cut-table__cell col-2 hidden-md"><strong>Round</strong></div>
            <div class="cut-table__cell col-2 hidden-md">
              <strong>{{ selectBy === 'horse' ? 'Rider' : 'Horse' }}</strong>
            </div>
            <div class="cut-table__cell col-2 hidden-md"><strong>Owner</strong></div>
            <div class="cut-table__cell col-1 hidden-md"><strong>Cutout</strong></div>
            <div class="cut-table__cell col-1 hidden-md"><strong>Horse-<br>work</strong></div>
            <div class="cut-table__cell col-1 hidden-md"><strong>Course</strong></div>
            <div class="cut-table__cell col-3 col-md-1"><strong>Score Total</strong></div>
          </div>
        </div>

        <div class="cut-table__body js-search-infinite">
          <div
            v-for="draw in draws"
            :key="draw.id"
            class="cut-table__row row m-0"
          >
            <div class="cut-table__cell col-2 hidden-md">
              <div class="account_id">
                <link-event
                  :round="draw.event.round"
                >
                  {{ draw.event.name }}
                </link-event>
              </div>
            </div>

            <div class="cut-table__cell col-9 display-md">
              <div><strong>Event: </strong>
                <link-event
                  :round="draw.event.round"
                >
                  {{ draw.event.name }}
                </link-event></div>
              <div><strong>{{ draw.event.round.name }}</strong></div>
              <div><strong>Horse:</strong> {{ draw.horse_name }} </div>
              <div><strong>Owner:</strong> {{ draw.owner_name }} </div>

              <div class="leaders-event__scores">
                <div class="leaders-event__scores-item"><span>Cutout</span>{{ formatScore(draw.cutout) }}</div>
                <div class="leaders-event__scores-item"><span>Horsework</span>{{ formatScore(draw.work) }}</div>
                <div class="leaders-event__scores-item"><span>Course</span>{{ formatScore(draw.course) }}</div>
              </div>
            </div>

            <div class="cut-table__cell col-2 hidden-md">{{ draw.event.round.name }}</div>

            <div class="cut-table__cell col-2 hidden-md">
              <div class="form-group">{{ selectBy === 'horse' ? draw.rider.name : draw.horse_name }}</div>
            </div>
            <div class="cut-table__cell col-2 hidden-md">
              <div class="nom_distance">{{ draw.owner_name }}</div>
            </div>

            <div class="cut-table__cell col-1 hidden-md">
              <div class="form-group">{{ draw.cutout ? formatScore(draw.cutout) : '-' }}</div>
            </div>

            <div class="cut-table__cell col-1 hidden-md">
              <div class="form-group">{{ draw.work ? formatScore(draw.work) : '-' }}</div>
            </div>

            <div class="cut-table__cell col-1 hidden-md">
              <div>{{ draw.course ? formatScore(draw.course) : '-' }}</div>
            </div>

            <div class="cut-table__cell col-3 col-md-1">
              <div>{{ formatScore(draw.round_score) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fetchData from '../../../../mixins/apiHelpers'
import SearchForm from './Search/SearchForm'
import LinkEvent from './Links/LinkEvent'
import formatScore from '../mixins/formatScore'

export default {
  inject: ['entity'],
  mixins: [formatScore],
  components: {
    'search-form': SearchForm,
    'link-event': LinkEvent
  },
  data() {
    return {
      draws: null,
      selectBy: null
    }
  },
  watch: {
    '$route.query': {
      handler(newQuery, oldQuery = {}) {
        const id = newQuery.id
        const select = newQuery.select

        if ((id && id !== oldQuery.id) || (select && select !== oldQuery.select)) {
          this.fetchDaws(id, select)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async fetchDaws(id, selectBy) {
      if (!id || !selectBy) return
      this.selectBy = selectBy
      const url = `/leaders/drafts/${this.entity.id}/${
        selectBy === 'competitor' ? 'riders' : 'horses'
      }/${id}/draws`
      fetchData(`${this.$api}${url}`, (response) => {
        this.draws = response.data.data.draws
      }, this)
    }
  }
}
</script>
<style scoped>
  .leaders a {
    color: var(--apperances-color) !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/Leaders/Listing/components/Search.vue